export const newsItemContentSelector = (state) => state.newsItem.content;
export const isLoadingSelector = (state) => state.newsItem.isLoading;
